import moment from "moment/moment";
//services
import { getTransfer } from "../../../utils/services/transfer";
// router dom
import { useLocation } from "react-router-dom";

export const excelColumnsPtBr = {
  Participante: "login",
  Empresa: "company",
  Origem: "origin",
  Destino: "destination",
  "Data Embarque": "boardingdate",
  "Hora Embarque": "boardingtill",
  "Data Chegada": "arrivaldate",
  "Hora Chegada": "arrivaltime",
  "Ponto De Encontro": "meetingpoint",
  "Nome Do Motorista": "drivername",
  "Telefone Do Motorista": "driverphone",
  "Informacoes Extras": "extrainformation",
};

export const excelColumnsPtBrUpdate = {
  IdTransfer: "id",
  Participante: "login",
  Empresa: "company",
  Origem: "origin",
  Destino: "destination",
  "Data Embarque": "boardingdate",
  "Hora Embarque": "boardingtill",
  "Data Chegada": "arrivaldate",
  "Hora Chegada": "arrivaltime",
  "Ponto De Encontro": "meetingpoint",
  "Nome Do Motorista": "drivername",
  "Telefone Do Motorista": "driverphone",
  "Informacoes Extras": "extrainformation",
};

export const excelColumnsPtBrDelete = {
  IdTransfer: "id",
  NomeParticipante: "name",
};

const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function formatDate(date) {
  try {
    const dateSplit = date.split("/");

    if (!dateSplit[0] || !dateSplit[1] || !dateSplit[2]) return undefined;

    const dateFormated = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;

    if (new Date(dateFormated)) {
      return dateFormated;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
}

function formatTime(time) {
  try {
    if (/^\d{2}:\d{2}$/.test(time) && moment(time, "HH:mm", true).isValid()) {
      return time;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
}

function emailValidate(email) {
  try {
    const emailValid = regexEmail.test(email);
    return emailValid ? email : undefined;
  } catch (error) {
    return undefined;
  }
}

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    login: emailValidate(row.login),
    origin: row.origin,
    destination: row.destination,
    company: row.company,
    boardingdate: formatDate(row.boardingdate),
    arrivaldate: formatDate(row.arrivaldate),
    boardingtill: formatTime(row.boardingtill),
    arrivaltime: formatTime(row.arrivaltime),
    meetingpoint: row.meetingpoint ? row.meetingpoint : "",
    drivername: row.drivername ? row.drivername : "",
    driverphone: row.driverphone ? row.driverphone : "",
    extrainformation: row.extrainformation ? row.extrainformation : "",
  };

  return formatedRow;
}

export function allExcelColumnsUpdate(row, index) {
  const formatedRow = {
    id: row.id,
    index,
    login: emailValidate(row.login),
    origin: row.origin,
    destination: row.destination,
    company: row.company,
    boardingdate: formatDate(row.boardingdate),
    arrivaldate: formatDate(row.arrivaldate),
    boardingtill: formatTime(row.boardingtill),
    arrivaltime: formatTime(row.arrivaltime),
    meetingpoint: row.meetingpoint ? row.meetingpoint : "",
    drivername: row.drivername ? row.drivername : "",
    driverphone: row.driverphone ? row.driverphone : "",
    extrainformation: row.extrainformation ? row.extrainformation : "",
  };

  return formatedRow;
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    id: row.id,
    index,
    name: row.name,
  };

  return formatedRow;
}

export async function getValidTransfers({ transfers, idEvent, isUpdate }) {
  try {
    const res = await getTransfer({
      idEvent: idEvent,
      limit: 10000,
      offset: 1,
      search: "",
      columnSearch: "login",
      hasGestaoClick: "false",
    });

    const listAllTransfers =
      res.findOneTransferData.count > 0 ? res.findOneTransferData.data : [];

    var transfersNotFounds = [];

    for (const transfer of transfers) {
      const search = listAllTransfers.find((e) => e.id === transfer.id);

      if (!search) {
        transfersNotFounds.push({
          ...transfer,
          id: undefined,
        });
      } else if (search && isUpdate && search.login.email !== transfer.login) {
        transfersNotFounds.push({
          ...transfer,
          login: undefined,
        });
      } else {
      }
    }

    return transfersNotFounds;
  } catch (error) {
    // console.log("get tranfers error", error);
    return [];
  }
}
